/** Browser routes that must not trigger auth-failure hard redirects (login loop). */
const PUBLIC_APP_PATHS = new Set([
  "/login",
  "/forgot-password",
  "/reset-password",
  "/password-reset-unavailable",
]);

export function normalizeAppPath(pathname: string): string {
  if (!pathname || pathname === "/") {
    return "/";
  }
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

export function isPublicAppPath(pathname: string): boolean {
  const normalized = normalizeAppPath(pathname);
  if (PUBLIC_APP_PATHS.has(normalized)) {
    return true;
  }
  return normalized.startsWith("/reset-password/");
}
